import { ENABLE_DISABLE_BUTTON_ON_API_CALL } from './actionTypes';

function buttonValue(value: boolean) {
  return {
    type: ENABLE_DISABLE_BUTTON_ON_API_CALL,
    data: value
  }
}

function receiveButtonState(value: boolean) {

  return (dispatch: any) => {

    dispatch(buttonValue(value));
  };
}

export {
  receiveButtonState
}